export default __webpack_public_path__ + "static/media/destination-tag-exercise.3ad05e23.png";